import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const areaContentDefaultVariants = {}
const areaContentCompoundVariants = []

const areaContentSlotNames = [
  [
    "factsGrid",
    "area-content__factsGrid"
  ],
  [
    "factsList",
    "area-content__factsList"
  ],
  [
    "factItem",
    "area-content__factItem"
  ],
  [
    "faqList",
    "area-content__faqList"
  ],
  [
    "faqItem",
    "area-content__faqItem"
  ],
  [
    "faqSummary",
    "area-content__faqSummary"
  ],
  [
    "faqCaret",
    "area-content__faqCaret"
  ],
  [
    "faqPanel",
    "area-content__faqPanel"
  ],
  [
    "articleBody",
    "area-content__articleBody"
  ]
]
const areaContentSlotFns = /* @__PURE__ */ areaContentSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, areaContentDefaultVariants, getSlotCompoundVariant(areaContentCompoundVariants, slotName))])

const areaContentFn = memo((props = {}) => {
  return Object.fromEntries(areaContentSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const areaContentVariantKeys = []
const getVariantProps = (variants) => ({ ...areaContentDefaultVariants, ...compact(variants) })

export const areaContent = /* @__PURE__ */ Object.assign(areaContentFn, {
  __recipe__: false,
  __name__: 'areaContent',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: areaContentVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, areaContentVariantKeys)
  },
  getVariantProps
})